import * as React from 'react';

export function TargetAudience() {
  return (
    <section className="bp-audience">
      <style>{`
        .bp-audience {
          padding: 72px 24px;
          background: #fff;
        }
        .bp-audience-inner {
          max-width: 800px;
          margin: 0 auto;
        }
        .bp-audience h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 36px;
          text-align: center;
        }
        .bp-audience-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }
        .bp-audience-col h3 {
          font-size: 16px;
          font-weight: 700;
          color: #1EAA25;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0 0 16px;
        }
        .bp-audience-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .bp-audience-col li {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 0;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f0f0f0;
        }
        .bp-audience-col li:last-child {
          border-bottom: none;
        }
        .bp-audience-col li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
          width: 20px;
          text-align: center;
        }
        @media (max-width: 640px) {
          .bp-audience-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          .bp-audience h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="bp-audience-inner">
        <h2>Llegamos a tu barrio</h2>
        <div className="bp-audience-grid">
          <div className="bp-audience-col">
            <h3>Entregamos en</h3>
            <ul>
              <li><i className="fa fa-home" /> Countries</li>
              <li><i className="fa fa-building" /> Barrios cerrados</li>
              <li><i className="fa fa-city" /> Condominios</li>
              <li><i className="fa fa-map-marked-alt" /> Housing</li>
              <li><i className="fa fa-tree" /> Barrios abiertos con acceso</li>
            </ul>
          </div>
          <div className="bp-audience-col">
            <h3>Que buscan</h3>
            <ul>
              <li><i className="fa fa-check" /> Frescura real, no de góndola</li>
              <li><i className="fa fa-check" /> Comodidad sin resignar calidad</li>
              <li><i className="fa fa-check" /> Variedad de frutas y verduras</li>
              <li><i className="fa fa-check" /> Ahorro de tiempo</li>
              <li><i className="fa fa-check" /> Productos de estación</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
